import { z } from "zod";
import { AgentProvider } from "./agents.ts";

/** One model as the picker shows it. `id` is what the CLI receives with --model. */
export const ModelInfo = z.object({
  id: z.string(),
  label: z.string(),
  description: z.string().nullable().default(null),
  isDefault: z.boolean().default(false),
  /** "account": reported live by the provider for this account. "catalog": from the public models.dev catalog. "alias": a moving alias the CLI resolves. */
  source: z.enum(["account", "catalog", "alias"]),
  releaseDate: z.string().nullable().default(null),
  reasoningEfforts: z.array(z.string()).default([]),
});
export type ModelInfo = z.infer<typeof ModelInfo>;

export const ModelCatalog = z.object({
  provider: AgentProvider,
  accountId: z.string().nullable(),
  models: z.array(ModelInfo),
  /** Where the list came from (for the small footer in the picker). */
  source: z.string(),
  /** True when the list is exactly what this account can use. */
  exact: z.boolean(),
  fetchedAt: z.string(),
  warning: z.string().nullable().default(null),
});
export type ModelCatalog = z.infer<typeof ModelCatalog>;
